// src/features/commands/useCommands.ts
import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../../lib/api';

export interface CommandOverride {
  command_name: string;
  enabled: boolean;
  custom_response: string | null;
}

export function useCommands(guildId: string | null) {
  return useQuery({
    queryKey: ['commands', guildId],
    queryFn: () => apiFetch<CommandOverride[]>(`/api/commands/${guildId}`),
    enabled: !!guildId,
  });
}

interface SaveCommandInput {
  guildId: string;
  commandName: string;
  enabled: boolean;
  customResponse: string | null;
}

export function useSaveCommand() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ guildId, commandName, enabled, customResponse }: SaveCommandInput) =>
      apiFetch(`/api/commands/${guildId}`, {
        method: 'PUT',
        body: JSON.stringify({ commandName, enabled, customResponse }),
      }),
    onSuccess: (_data, variables) => {
      // Refetch this guild's command list so the saved state (and any
      // server-side normalization) is reflected immediately.
      queryClient.invalidateQueries({ queryKey: ['commands', variables.guildId] });
    },
  });
}
